module.exports = __webpack_public_path__ + "img/65_10.9536d93b.png";